import { DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import { ContainedButton, Dialog, TextButton } from '@shared/components';
import { useProductsTFunction } from '@retail/products/i18n';
import { CheckIcon } from '@shared/custom-icons';

interface Props {
  isOpen: boolean;
  closeDialog: () => void;
  successText: string;
  assortmentTitle: string;
  assortmentId: number;
  navigate: (assortmentId: number) => void;
}

export function SuccessAddingItemsDialog({
  isOpen,
  closeDialog,
  successText,
  assortmentTitle,
  assortmentId,
  navigate,
}: Props) {
  const t = useProductsTFunction();
  return (
    <Dialog open={isOpen} onClose={() => closeDialog()} fullWidth maxWidth="sm">
      <DialogTitle>{t('products.mgItem.addItemsToAssortment.itemAdded')}</DialogTitle>
      <DialogContent sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <CheckIcon />
        <Stack>
          {successText}
          <Typography color="text.secondary">
            {t('products.mgItem.addItemsToAssortment.addedIn', {
              assortment: `"${assortmentTitle}"`,
            })}
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <TextButton onClick={() => closeDialog()} size="small">
          {t('products.mgItem.addItemsToAssortment.close')}
        </TextButton>

        <ContainedButton onClick={() => navigate(assortmentId)} size="small">
          {t('products.mgItem.addItemsToAssortment.goToAssortment')}
        </ContainedButton>
      </DialogActions>
    </Dialog>
  );
}
